// Event copy contract shared between Eva Insights and Eva People.
//
// KEEP IN SYNC with eva_people/src/lib/EventContract.js — structurally
// identical (same functions, signatures, cases). The only intentional
// divergence is DEFAULT_MESSAGE below, which tracks each app's audience.
const DEFAULT_MESSAGE = 'Activity detected';

export function formatEventContext(data = {}) {
  const parts = [];
  if (data.country) parts.push(data.country);
  else if (data.region) parts.push(data.region);
  if (data.department) parts.push(data.department);
  return parts.length > 0 ? ` • ${parts.join(' • ')}` : '';
}

export function formatEventTopic(data = {}, fallback = 'General') {
  return data.sub_topic || data.topic || data.category || fallback;
}

export function formatFeedbackSentiment(feedback) {
  return feedback === 'positive' ? 'Helpful' : 'Needs improvement';
}

export function formatDocumentDetail(data = {}) {
  return formatEventTopic(data, 'General');
}

export function formatEventMessage(event) {
  const data = event?.data || {};
  const context = formatEventContext(data);

  switch (event?.type) {
    case 'retrieval':
    case 'query':
      return `Question: ${formatEventTopic(data, 'General')}${context}`;
    case 'feedback':
      return `${formatFeedbackSentiment(data.feedback)} on ${formatEventTopic(data, 'General')}${context}`;
    case 'thumbs_up':
      return `Helpful on ${formatEventTopic(data, 'General')}${context}`;
    case 'thumbs_down':
      return `Needs improvement on ${formatEventTopic(data, 'General')}${context}`;
    case 'comment_added':
      return `Feedback comment on ${formatEventTopic(data, 'General')}${context}`;
    case 'content_gap':
      return `Gap: ${formatEventTopic(data, 'General')}${context}`;
    case 'document_view':
      return `Document viewed: ${formatDocumentDetail(data)}${context}`;
    case 'document_upload':
      return `Document uploaded: ${formatDocumentDetail(data)}${context}`;
    case 'bookmark':
      return `Response bookmarked${context}`;
    case 'share':
      return `Response shared${context}`;
    case 'copy_response':
      return `Response copied${context}`;
    case 'badge_earned':
      return `Badge earned: ${data.badge_name || 'achievement'}${context}`;
    case 'streak_achieved':
      return `${data.streak_days ? `${data.streak_days}-day streak` : 'Streak achieved'}${context}`;
    case 'leaderboard_rank_up':
      return `Leaderboard rank: ${data.new_rank ? `#${data.new_rank}` : '#?'}${context}`;
    case 'session_started':
      return `Session started${context}`;
    case 'session_completed':
    case 'session_summary':
      return `Session completed${context}`;
    case 'login':
      return `User logged in${context}`;
    case 'logout':
      return `User logged out${context}`;
    case 'user_invited':
      return `User invited to ${data.invited_department || 'the team'}`;
    case 'group_created':
      return `Group created: ${data.group_name || 'a new group'}`;
    case 'performance_update':
      return `${data.documents_updated || 0} documents updated`;
    default:
      return DEFAULT_MESSAGE;
  }
}
